import React, { useState } from "react";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import GridViewCard from "../GridView/GridViewCard";
import ListViewCard from "../ListView/ListViewCard";

const ViewProducts = ({ title, products }) => {
  const [view, setView] = useState("list");

  const listView = (
    <div className="flex flex-col gap-4 py-10">
      {new Array(4).fill(0).map((_, index) => (
        <ListViewCard key={index} />
      ))}
    </div>
  );

  const gridView = (
    <div className="grid grid-cols-4 gap-4 py-10">
      {new Array(15).fill(0).map((_, index) => (
        <GridViewCard key={index} product={products[index % 5]} />
      ))}
    </div>
  );
  return (
    <>
      <FilterHeader title={title} setView={setView} view={view} />

      {view === "list" ? listView : gridView}
    </>
  );
};

export default ViewProducts;
